module.exports = __webpack_public_path__ + "static/media/shoes.2185703a.png";